/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { VocabWordReviewLevelDto } from "./VocabWordReviewLevelDto";
export type VocabWordReviewLevelsDto = {
  language: VocabWordReviewLevelsDto.language;
  /**
   * 쉬운 급수부터(N5→N1)
   */
  levels: Array<VocabWordReviewLevelDto>;
};
export namespace VocabWordReviewLevelsDto {
  export enum language {
    EN = "en",
    JA = "ja",
    KO = "ko",
  }
}
